import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Text } from '@concepta/react-material-ui';
import FormLabel from 'app/components/FormLabel';
import LeftRightInfo from 'app/components/LeftRightInfo';
import { ContactMethod } from 'app/components/ContactMethodToggle';
import { isMobile } from 'utils/isMobile';
import { OrderCheckoutOutputInterface } from 'ks-common';

const getContactMethodLabel = (method: number) => {
  switch (method) {
    case ContactMethod.SMS:
      return 'Text Message (SMS)';
    case ContactMethod.WHATSAPP:
      return 'WhatsApp';
    default:
      return 'Unknown';
  }
};

const PreferredContactMethod = () => {
  const location = useLocation();
  const thankYouState = location?.state as OrderCheckoutOutputInterface | null;

  const stateCustomer = thankYouState?.Customer;
  if (!stateCustomer) return null;

  const preferredContactMethod = stateCustomer.PreferredContactMethod;
  const primaryCellPhone = stateCustomer.CellPhone;
  const countryCodeCellPhone = stateCustomer.CountryCodeCellPhone;

  if (preferredContactMethod === undefined || preferredContactMethod === null)
    return null;

  const getFormattedPhoneNumber = () => {
    if (!primaryCellPhone) return '';
    let cc = (countryCodeCellPhone || '').toString().trim();
    if (cc && !cc.startsWith('+')) cc = `+${cc}`;
    return cc ? `${cc} ${primaryCellPhone}` : `${primaryCellPhone}`;
  };

  const contactMethodLabel = getContactMethodLabel(preferredContactMethod);
  const formattedPhone = getFormattedPhoneNumber();

  return (
    <Box mt={3} borderTop="1px solid" borderColor="primary.darker" pt={2}>
      <FormLabel mb={1}>Preferred Contact Method:</FormLabel>

      <LeftRightInfo
        sx={{ mt: 1 }}
        left={
          <Text fontSize={isMobile ? 14 : 16} fontWeight={400}>
            Phone Number
          </Text>
        }
        right={
          <Box display="flex" alignItems="center">
            <Text fontSize={isMobile ? 14 : 16} fontWeight={400}>
              {formattedPhone}
            </Text>
          </Box>
        }
      />

      <LeftRightInfo
        sx={{ mt: 1 }}
        left={
          <Text fontSize={isMobile ? 14 : 16} fontWeight={400}>
            Contact Method
          </Text>
        }
        right={
          <Box display="flex" alignItems="center">
            <Text fontSize={isMobile ? 14 : 16} fontWeight={400}>
              {contactMethodLabel}
            </Text>
          </Box>
        }
      />
    </Box>
  );
};

export default PreferredContactMethod;
